import {EntityApiService, ApiClientService} from '@dofleini/security';

class NomenclaturesCompaniesApiService extends EntityApiService {

    getOneCompany = ({companyId}) => ApiClientService.get(this.getPath(`/${companyId}`));

}

export default new NomenclaturesCompaniesApiService('/ms-core/api/enterprise');
